import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'cas-side-navigation-divider',
  standalone: true,
  template: '<hr class="text-cloud-dark mt-0 mb-6">',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SideNavigationDividerComponent {}
